import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-chevron-down\"><path d=\"m10 11.59 4.577-4.715 1.048 1.08L10 13.75 4.375 7.955l1.048-1.08L10 11.59Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol